import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './redux/store'
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { KotProvider } from './modules/context/kotContext';
import { ShowSidebarProvider } from './modules/context/showSidebarContext';
import { NcProvider } from './modules/context/ncContext';
//import store from './redux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
<ShowSidebarProvider>
  <KotProvider>
  <NcProvider>
  <BrowserRouter>
  <ChakraProvider >
 
    <App />
 
  </ChakraProvider>
  </BrowserRouter>
  </NcProvider>
  
  </KotProvider>
  </ShowSidebarProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
